<template>
<div>
  <autocomplete label="Add job" placeholder="Job position or company"
    v-model="text" :showSuggestions="suggestions.length > 0"
    v-on:keyup.enter="onReturnKey">
  <row-card v-for="(job, index) in suggestions" :key="index" :job="job"
    class="job-card"
    @click="onCardClicked(job)">
  </row-card>
  </autocomplete>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Autocomplete from '@/components/general/autocomplete-text-field'
import RowCard from '@/components/jobs/job-row-card'
import isemail from 'isemail'

export default {
  components: { Autocomplete, RowCard },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('jobseekerReferral', [
      'suggestions'
    ])
  },
  methods: {
    ...mapActions('jobseekerReferral', [
      'updateSuggestions'
    ]),
    ...mapMutations('jobseekerReferral', [
      'setSuggestions',
      'addSelected'
    ]),
    updateText (text) {
      if (text.length > 3) {
        this.updateSuggestions(text)
      } else {
        this.setSuggestions([])
      }
    },
    onCardClicked (job) {
      this.addSelected(job)
      this.text = ''
    },
    onReturnKey () {
      const email = this.text.toLowerCase()
      if (isemail.validate(email)) {
        const exists = this.suggestions.find(x => {
          return x.account ? x.account.email === email : false
        })
        if (exists) {
          this.addSelected(exists)
        } else {
          this.addSelected(this.text)
        }
        this.text = ''
      }
    }
  },
  watch: {
    text () {
      this.updateText(this.text)
    }
  },
  data () {
    return {
      text: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.card.job-card {
  cursor: pointer;
  border-left: 0;
  border-right: 0;
}

.card.job-card:hover {
  background-color: $hover-background;
}

.card.job-card:first-child {
  border-top: 0;
}
.card.job-card:last-child {
  border-bottom: 0;
}
.card.job-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.job-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobs-autocomplete-field.vue